module.exports = __webpack_public_path__ + "media/images/home/about_us/AV0_4653-27a202709eb84ad46d52a45dcabaf83b.jpg";